import { PackageType } from '../../api/package';

export enum CartActionKind {
  ADD_TO_CART = 'ADD_TO_CART',
  REMOVE_FROM_CART = 'REMOVE_FROM_CART'
}

export type CartActionType = typeof addToCart | typeof removeFromCart;

type AddToCartType = {
  type: CartActionKind.ADD_TO_CART;
  payload: { pkg: PackageType };
};

export function addToCart(pkg: PackageType): AddToCartType {
  return {
    type: CartActionKind.ADD_TO_CART,
    payload: { pkg }
  };
}

type RemoveFromCartType = {
  type: CartActionKind.REMOVE_FROM_CART;
  payload: { pkgId: number };
};

export function removeFromCart(pkgId: number): RemoveFromCartType {
  return {
    type: CartActionKind.REMOVE_FROM_CART,
    payload: { pkgId }
  };
}
